import { useState, useEffect } from "react";
import axios from 'axios'
import { useToast } from "../../toastHook";

export const CreateRunAOsComponent = () => {

    const [form, setForm] = useState({
        compte: '',
        encoding: '',
        nom : ''

    })
    const { display } = useToast();
    const [uploading, setUploading] = useState(false);
    const [avalaibleReaders, setAvalaibleReaders] = useState([]);

    useEffect(() => {
        axios.get("/api/aoutility/enginereaders")
            .then(response => {
                if (response.data && response.data.length > 0) {

                    response.data.sort();

                    setAvalaibleReaders(response.data);

                    setForm({ ...form, compte: response.data[0].name, encoding: response.data[0].encoding });
                }
});
    }, []);

    const handleInputChange = (event) => {
        const value = event.target.value;
        const name = event.target.name;

        setForm({ ...form, [name]: value })
    }

    const onCompteChange = event => {

        var compte = event.target.value;

        var encoding = avalaibleReaders.find(x => x.name === compte)?.encoding;

        setForm({ ...form, compte: compte, encoding: encoding });

    }

    const handleSubmit = (event) => {

        event.preventDefault();


        if (uploading) {
            return;
        }

        setUploading(true);

        const formData = new FormData();

        formData.append("nom", form.nom);
        formData.append("compte", form.compte);
        formData.append("encoding", form.encoding);
        formData.append("aoZip", event.target.customFile.files[0]);


        axios.post('/api/aosreaderjob/add', formData)
            .then(response => {

                display({
                    titre: 'run démarré',
                    text: `le  run '${form.nom} pour le compte ${form.compte} a été démarré`,
                    severity: 'success'
                });

                event.target.reset();
                setForm({
                    compte: '',
                    encoding: '',
                    nom: ''

                });


                setUploading(false);
            })
            .catch(() => { setUploading(false); });
    }

    return <div>
        <form onSubmit={ handleSubmit } >
            <div className="card row-cols col-12">
                <div className="card-header row justify-content-center"><h3>Créer un run d'ao</h3></div>
                <div className="card-body">
            <div className="mb-3">
                <label htmlFor="runName" className="form-label">Nom du run</label>
                <input type="text" name="nom" className="form-control" id="runName" aria-describedby="runNameHelp" required value={form.nom} onChange={ handleInputChange } />
                    <div id="runNameHelp" className="form-text">nom du run qui sera affiché dans la pages des runs d'AOs</div>
            </div>
            <div className="mb-3">
                <label htmlFor="compte" className="form-label">Compte</label>
                        <select name="compte" className="form-select" id="compte" aria-describedby="compteHelp" required value={form.compte} onChange={onCompteChange }>
                            <option value="" hidden>selectionnez</option>
                            {avalaibleReaders.map(x => <option key={x.name} value={x.name}>{x.name}</option>)}
                        </select>
                        <div id="compteHelp" className="form-text">le compte à utiliser pour le zip importer: par exemple carrefour</div>
            </div>
            <div className="mb-3">
                <label htmlFor="encoding" className="form-label">encoding</label>
                <input type="text" name="encoding" className="form-control" id="encoding" aria-describedby="encodingHelp" required value={form.encoding} onChange={handleInputChange} />
                <div id="encodingHelp" className="form-text">le encoding à utiliser pour le zip importer: par exemple carrefour</div>
            </div>
            <div className="mb-3">
                <label htmlFor="customFile" className="form-label">Zip des aos</label>
                        <input type="file" name="file" className="form-control" id="customFile" htmlFor="customFileHelp" required />
                        <div id="customFileHelp" className="form-text">le zip contient les aos à traîter</div>
                    </div>
                </div>
                <div className="card-footer row justify-content-center" ><input type="submit" className="btn btn-lg btn-primary col-4" value={uploading ? "upload fichier en cours ..." : "Lancer le run"} disabled={ uploading } ></input></div>
                </div>
        </form>
            </div>
}















